module Meevo.Plugins.Client {
    "use strict";
    /**
    * NotesSection Section -- need aggregate model for handling functionality.
    */
    export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {
        public canReadPrivateNoteAccess: boolean = false;
        public canAddPrivateNoteAccess: boolean = false;
        public canEditPrivateNoteAccess: boolean = false;
        public canDeletePrivateNoteAccess: boolean = false;
        public canSeeAddPrivateNoteAccess: boolean = false;
        public canSeeEditPrivateNoteAccess: boolean = false;
        public canSeeDeletePrivateNoteAccess: boolean = false;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            protected securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService,
            protected modalService?: Meevo.Components.Modal.IModalService
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey,
                translateService
            );

            var privateNoteKeys: string[] = [
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE,
            ];
            securityService
                .checkAndCache(privateNoteKeys)
                .then((accessValues: Model.SecurityItem[]) => {
                    let readAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                    if (readAccess) {
                        this.canReadPrivateNoteAccess = (readAccess.securityAccess != Model.SecurityAccessEnum.Hide);
                    }
                    let addAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE });
                    if (addAccess) {
                        this.canAddPrivateNoteAccess = (addAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                        this.canSeeAddPrivateNoteAccess = (addAccess.securityAccess != Model.SecurityAccessEnum.Hide);
                    }
                    let editAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE });
                    if (editAccess) {
                        this.canEditPrivateNoteAccess = (editAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                        this.canSeeEditPrivateNoteAccess = (editAccess.securityAccess != Model.SecurityAccessEnum.Hide);
                    }
                    let deleteAccess = _.findWhere(accessValues, { key: Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_NOTES_PRIVATE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE });
                    if (deleteAccess) {
                        this.canDeletePrivateNoteAccess = (deleteAccess.securityAccess == Model.SecurityAccessEnum.Grant);
                        this.canSeeDeletePrivateNoteAccess = (deleteAccess.securityAccess != Model.SecurityAccessEnum.Hide);
                    }
                });
        }
        public isItemOwned(item: any): boolean {
            return Model.Guard.isSomething(item) && item.locationId === this.identityService.current().locationId;
        }
        public isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }
        public onPerformAction(item: any, canEditModelEvenWhenRestricted: boolean, actionOnItem: { (item: any): void }) {
            if (canEditModelEvenWhenRestricted) {
                actionOnItem(item);
            }
            else {
                this.modalService.alert("MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT");
            }
        }
        public privacyChanged(item) {
            if (item.isPrivate) {
                item.isAppointmentBooked = false;
                item.isCheckIn = false;
                item.isCheckOut = false;
            }
        }
        public showNoPermissionAlert() {
            return this.modalService.alert("MESSAGE_NO_PRIVATE_NOTE_PERMISSIONS");
        }
   }
}